export default {
  title: 'Soumissions',
  quotes: 'Soumission',
  alliance_submission: "Soumission de l'alliance",
  my_submission: 'Ma soumission',
  alliance_offer: 'L’offre de votre Alliance',
  total_estimation: 'Total de l’estimation',
  back_to_quotes: 'Retour à mes soumissions',
  request_change_title: 'Demande d’ajustement',
  noQuotes: "Vous n'avez pas encore créé des soumissions.",
  published_quotes_title: 'MES SOUMISSIONS EXISTANTES',
  load_more_quotes: 'Charger plus de soumissions',
  manage: 'Gérer',
  prospectQuotesLabel: 'Demandes de vos prospects',
  prospectQuotesTitle: 'Créer un projet de soumission',
  selectProjectLabel: 'Sélectionner un projet',
  selectProjectPlaceholder: 'Cliquer pour voir vos prospects actifs',
  create_submission_title: 'Créer une soumission.',
  create_submission_button: 'Créer une nouvelle soumission',
  pending_requests_empty: 'Aucune demande pour le moment',
  steps_previous: 'Étape précédente',
  steps_next: 'Étape suivante',
  offerLabel: 'Offre',
  addAllianceLabel: 'Ajouter une Alliance',
  addAlliancePlaceholder: 'Selectionnez une alliance',
  createQuoteTitle: 'Créer un projet de soumission',
  allianceSelectionTitle: "Sélectionner les membres de l'alliance",
  createQuote: 'Créer la soumission',
  quoteStatus: 'Statut',
  childQuoteOfferPending: 'En attente',
  viewSubmissionButtonLabel: 'Voir la soumission',
  viewProjectButtonLabel: 'Voir le projet',
  quoteRequestInfo: {
    publishedDate: 'Date de publication',
    submittedDate: 'Date de soumission',
    projectInfo: 'Informations du projet',
    projectName: 'Nom du projet',
    companyName: "Nom de l'entreprise",
    priceRange: 'Budget',
    dueDate: "Date d'échéance",
    startDate: 'Date de commencement',
    onsite: 'Travail en présentiel',
    city: 'Lieu',
    jobDescription: 'Description du projet',
  },
  my_submissions: 'Mes Soumissions',
  confirmRetireTitle: 'Confirmer le retrait',
  confirmActivateButton: 'Activer',
  confirmRetireMessage:
    'Voulez-vous vraiment retirer votre soumission pour le projet : {{jobTitle}} ?',
  confirmActivateTitle: 'Confirmer l’activation',
  confirmActivateMessage:
    'Voulez-vous vraiment activer votre soumission pour le projet : {{jobTitle}} ?',
  view_all_my_submissions: 'Voir tous mes soumissions',
  createQuoteModal: {
    allianceSelectionTitle: 'Vos Alliances',
    addOfferSectionTitle: 'Mon offre',
    addOfferButtonLabel: 'Ajouter une offre',
    taskTitle: 'Tâche {{number}}',
    taskNamePlaceholder: 'Nom de la tâche',
    taskDescriptionLabel: 'Description de la tâche',
    typeLabel: 'Type',
    quantityLabel: 'Quantité',
    unitPriceLabel: 'Prix unitaire',
    totalLabel: 'Total',
    addLineButtonLabel: 'Ajouter une ligne',
    additionalNotesLabel: 'Notes additionnelles',
    changeRequestLabel: 'Demande d’ajustement',
    additionalNotesPlaceholder:
      'Précisez votre méthodologie, vos délais ou toute autre information pertinente pour le client...',
    saveOfferButtonLabel: 'Enregistrer',
    savingOfferButtonLabel: 'Enregistrement...',
    pricingType: {
      hourly: 'Horaire',
      flat_rate: 'Forfait',
      unit: 'Unité',
      fee: 'Frais',
      adjustment: 'Ajustement',
      tax: 'Taxes',
    },
    hourlyRateLabel: 'Taux horaire',
    hourlyRatePlaceholder: 'Entrez votre taux horaire (ex: 50 pour 50$)',
    timeLabel: "Nombre d'heures",
    timePlaceholder: "Entrez le nombre d'heures (ex: 10)",
    descriptionLabel: 'Description',
    totalAmountSectionTitle: 'Grand total',
    myOfferTotalAmountLabel: 'Votre total',
    addMyOfferButtonLabel: 'Ajouter mon offre',
    addingMyOfferButtonLabel: 'Ajout de mon offre...',
    saveDraftButtonLabel: 'Enregistrer le brouillon',
    submitQuoteButtonLabel: 'Envoyer la soumission',
    submitAdjustedQuoteButtonLabel: 'Envoyer l’ajustement',
    submitQuoteWithCreditButtonLabel: 'Utiliser 1 jeton et envoyer la soumission',
    submitAdjustedQuoteWithCreditButtonLabel: 'Utiliser 1 jeton et envoyer l’ajustement',
    saveAndSubmitButtonLabel: 'Enregistrer et envoyer la soumission',
    submittingButtonLabel: 'Envoi en cours...',
    cancelSubmissionButtonLabel: 'Abandonner la soumission et fermer',
    backToSubmissionButtonLabel: 'Annuler et Retourner à la soumission',
    backToSubmissionsButtonLabel: 'Retour à la soumission',
    submitConfirmationTitle: 'Projet de la soumission envoyé',
    submitConfirmationText: '<bold>{{requesterName}}</bold> vous repondra sous peu.',
    unknownErrorCreatingTasks: 'Une erreur inconnue est survenue lors de la création des tâches',
    removeAllianceConfirmTitle: "Retirer l'alliance",
    cancelAllianceConfirmTitle: 'Annuler la demande de participation.',
    removeAllianceConfirmText:
      'Vous êtes sur le point de retirer {{name}} de votre soumission. Un avis lui sera envoyé.',
    cancelAllianceConfirmText:
      "Vous êtes sur le point d'annuler la demande de participation envoyée à {{name}}. Un avis lui sera envoyé.",
    restoreAllianceButtonLabel: 'Restaurer',
    showAllianceButtonLabel: "Voir l'alliance",
    removeAllianceButtonLabel: "Retirer l'alliance",
    offerLabel: 'Offre',
    quoteRequestLabel: 'Demande',
    loadMoreQuotes: 'Charger plus de soumissions',
    submitDisabledNoOffer: 'Vous devez ajouter votre offre pour envoyer votre soumission.',
    submitDisabledChangesNotSaved:
      'Vous devez enregistrer vos modifications avant d’envoyer la soumission.',
    submitDisabledAlliances:
      'Tous les membres de l’alliance doivent soumettre leur offre pour envoyer la soumission.',
    quoteAlreadySubmitted:
      'Vous ne pouvez plus modifier cette soumission car elle a déjà été soumise au client.',
    unknownInviteAllianceError: "Une erreur inconnue est survenue lors de l'envoi de la demande.",
    unknownCancelAllianceRequestError:
      "Une erreur inconnue est survenue lors de l'annulation de la demande.",
    unknownRetireAllianceError: "Une erreur inconnue est survenue lors du retrait de l'alliance.",
    unknownErrorUpdatingServiceCategory:
      'Une erreur inconnue est survenue lors de la mise à jour du service',
    sendQuoteAllianceRequest: 'Envoyer la demande',
    sendingQuoteAllianceRequest: 'Envoi de la demande...',
    cancelQuoteAllianceRequest: 'Annuler la demande',
    cancellingQuoteAllianceRequest: 'Annulation de la demande...',
    removeFromSubmission: 'Enlever de la soumission',
    removingFromSubmission: 'Enlever de soumission...',
    inviteAllianceQuoteTitle: 'Invitation de participation à : <bold>{{jobTitle}}</bold>',
    inviteSentMessage: "L' invitation a été envoyée à <bold>{{freelancerName}}</bold>.",
    submitError: "Une erreur est survenue lors de l'envoi de la soumission. Veuillez réessayer.",
    removeAlliancesConfirmTitle: "Confirmer le retrait de l'alliance",
    removeAlliancesConfirmText:
      'Vous êtes sur le point de retirer {{name}} de votre soumission. Un message lui sera envoyé.',
    submitDisabledInsufficientCredits:
      'Jetons insuffisants. {{count}} jeton(s) requis pour soumettre à un projet public.',
    close: 'Fermer',
    quantityColumnHeader: 'Quantité',
    savingButtonLabel: 'Enregistrement...',
    taskDescriptionColumnHeader: 'Description de la tâche',
    taskDescriptionPlaceholder: 'Description de la tâche',
    totalAmountLabel: 'Grand total',
    typeColumnHeader: 'Type',
    unitPriceColumnHeader: 'Prix unitaire',
    backToQuote: 'Retour à la soumission',
    inviteMessagePlaceholder: 'Votre message',
    inviteSentTitle: 'Demande envoyée',
  },
  teamMembers: 'Équipe',
  acceptQuote: 'Accepter la soumission',
  declineQuote: 'Refuser la soumission',
  sub_total: 'Sous-total',
  time: 'Temps',
  quote_change_message_for_label: 'Votre message pour <bold>{{name}}</bold>',
  quote_change_message_hint:
    'Pour demander un ajustement à <bold>{{name}}</bold> veuillez lui fournir vos explications.',
  quote_change_notification: '<bold>{{name}}</bold> sera notifié.',
  quote_change_request_sent: 'Demande d’ajustement envoyée',
  change_has_been_requested: 'Modification demandée',
  request_changes: 'Demander un ajustement',
  requestChangeMessagePlaceholder: 'Vos explications',
  requestChangeError:
    "Une erreur inconnue est survenue lors de la demande d'ajustement. Veuillez réessayer ou contacter le support.",
  errors: {
    jobNotAvailable:
      "Vous ne pouvez plus soumettre votre dévis car le projet associé n'est plus disponible.",
    quoteAllianceRetired:
      'Vous ne pouvez plus soumettre votre dévis car votre invitation a été annulée.',
    submitError:
      "Une erreur inconnue est survenue lors de l'envoi de la soumission. Veuillez réessayer ou contacter le support.",
    insufficientCredits: 'Crédits insuffisants',
  },
  quote_ownership_statuses: {
    principal: 'Soumissionnaire principale',
    alliance: 'Soumissionnaire  alliée',
  },
  pendingRequestsTitle: 'Demandes en attente',
  viewProspectsButton: 'Voir mes contacts',
  bigStepsTitle: 'Les grandes étapes',
  bigStepsSubtitle: 'Pour bien commencer, voici ce que vous devez savoir !',
  stepTitle: 'Remplir le formulaire',
  stepDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  needHelpText: "Besoin d'aide ?",
  callToActionButton: "Appel à l'action",
  creating: 'Création...',
  retry: 'Réessayer',
  createQuoteErrorTitle: 'Erreur lors de la création',
  createQuoteErrorHint:
    'Une erreur est survenue lors de la création de votre soumission. Veuillez réessayer.',
  print: {
    printButton: 'Imprimer',
    documentLabel: 'Soumission',
    principalLabel: 'Soumissionnaire principal',
    freelancerLabel: 'Soumissionnaire',
    tasksLabel: 'Détail des tâches',
    footer: 'Document généré le {{date}} via Pigeons.',
    notFound: 'Soumission introuvable ou accès refusé.',
  },
  bigSteps: {
    title: 'Les grandes étapes',
    subtitle: 'Pour bien commencer, voici ce que vous devez savoir !',
    steps: {
      one: {
        title: 'Consulte le projet',
        description: 'Prends connaissance du mandat, des attentes et des dates clés.',
      },
      two: {
        title: 'Envoie ta proposition',
        description: 'Décris comment tu réaliserais le mandat et à quel prix.',
      },
      three: {
        title: 'Envoie ta soumission',
        description: 'Le recruteur la reçoit et peut te contacter rapidement.',
      },
    },
    needHelp: "Besoin d'aide ?",
    cta: 'Trouver un projet',
  },
  my_offer: 'Mon offre',
  grand_total: 'Grand total',
  no_alliance: 'Aucune alliance',
  activating: 'Activation en cours...',
  retiring: 'Retrait en cours...',
  modify: 'Modifier',
  edit_submission: 'Modifier ma soumission',
  cancel_submission: 'Annuler mon offre',
  confirmRetireButton: 'Retirer',
  quoteActivateError: "Échec de l'activation de la soumission",
  quoteRetireError: 'Échec du retrait de la soumission',
  your_alliances: 'Vos alliances',
  team: 'Équipe',
  tasks: 'Tâches',
  role: 'Rôle',
  close: 'Fermer',
  addOfferSectionTitle: 'Mon offre',
} as const;
